import React from "react";
import "./Chat.css";
import { useAuth0 } from "@auth0/auth0-react";

const UserUtterance = ({ data, showDialogCodes }) => {
    const { user } = useAuth0();
    let user_profile=user?.oi_profile?.toLowerCase() 
    console.log(showDialogCodes, "showDialogCodes")
    Object.size = function (obj) {
        var size = 0,
            key;
        for (key in obj) {
            if (obj.hasOwnProperty(key)) size++;
        }
        return size;
    };

    let nlu_intent = JSON.parse(data.nlu_data);
    nlu_intent = Object.size(nlu_intent) !== 0 ? Object.keys(nlu_intent)[0] : "";
    let asr_corrected_text = data.asr_corrected_text || "NA";
    let is_low_confidence_text = data.is_low_confidence_text;
    // console.log("is_low_confidence_text", is_low_confidence_text);
    let original_text = data.original_text
    let background_color = data.utterance_from === "ASR-2" ? "#FFFF00" : "#e2e3e3";
    let _display = data.utterance_from === "ASR-2" && showDialogCodes === false ? "none" : "flex";
    console.log(_display, "_display")
    return (
        <div
            style={{
                display: `${_display}`,
                flexDirection: "column",
            }}
        >
            <div
                style={{
                    display: "flex",
                    justifyContent: "flex-end",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        background:user_profile=="demo"?"white": `${background_color}`,
                        color: "#020507",
                        maxWidth: user_profile=="demo"?"30%":"60%",
                        minWidth: user_profile=="demo"?"30%":"60%",
                        padding: "0.1rem 1rem 0.1rem 1.7rem",
                        borderRadius: "5rem 0 5rem 5rem",
                        margin: "4px",
                        border: user_profile=="demo"?"0.3px solid #4a4747":"none"
                    }}
                >
                    <div className="chatMessage" style={{ alignSelf: "flex-end" }}>
                        {data.utterance}{" "} {original_text && original_text != data.utterance && <>({original_text})</>}
                        {/* Only show ASR Correction if it is different from user utterance. */}
                        {user?.oi_profile?.toLowerCase() !== "customer"  && asr_corrected_text.trim().toLowerCase() !==
                            data.utterance.trim().toLowerCase() && (
                                <div className="asrCorrectionText">
                                    <i>[{asr_corrected_text}]</i>
                                </div>
                            )}

                    </div>
                    <div style={{ display: "flex-end", justifyContent: "space-between" }}>
                        <div className="chatTimingUser"  style={{fontSize:"9px"}}>
                            {new Date(data.creation_date).toLocaleString("en-US", {
                                year: "numeric",
                                month: "short",
                                day: "numeric",
                                hour: "numeric",
                                minute: "numeric",
                                second: "numeric",
                            })}
                        </div>
                    </div>
                </div>
                <center
                    style={{
                        backgroundColor:user_profile=="demo"?"black": "#FA6F57",
                        color:user_profile=="demo"?"white": "white",
                        fontSize: "9px",
                        // verticalAlign: "center",
                        padding: "5px",
                    }}
                    className="img-circle"
                >
                    U
                </center>
                {/* <img
          src="http://placehold.it/25/FA6F57/fff&text=U"
          alt="U"
          className="img-circle"
        /> */}
            </div>
            {user?.oi_profile?.toLowerCase() !== "customer" && user?.oi_profile?.toLowerCase() !== "demo" && <div className="userUtteranceIntent">
                {original_text != data.utterance ? "{original text: " + data.original_text + "} " : ""}

                &#123; intent: {nlu_intent} &#125; &#123;confidence:{" "}
                {is_low_confidence_text === 0 ? "true" : "false"}&#125;
            </div>}
        </div>
    );
};

export default UserUtterance;
